import React, { useEffect, useState } from "react";
import Button from "../bootstrap/Button.jsx";
import DropdownMenu from "../common/DropdownMenu.jsx";
import { fetchJson } from "../../helpers/index.js";
import LoadingIndicator from "../common/loading_indicator.jsx";

import { search_projects_by_identifier_path } from '~/routes';

const ACTIVE_STYLE =  {backgroundColor: '#5c6276', color: '#FFF'}
const NO_FILTER = ['all', I18n.t('all').toUpperCase()]

const FilterButton = ({children, ...rest}) =>  <Button type='default' size='sm' {...rest}>{children}</Button>

const ProjectMenuItem = ({project, handleItemClick}) =>
    <li className='dropdown-item'>
      <a href='#' onClick={(e) => {e.preventDefault(); handleItemClick(project)}}>{project[1]}</a>
    </li>

const MenuContent = ({searchTerm, handleTermChange, projects, handleItemClick, loading}) => {
  const noItemsText = searchTerm.length < 3 ? I18n.t('type_to_search_chars', {chars: 3}) : I18n.t('no_projects');

  return <>
    <input autoFocus className='form-control input-sm' style={{width: 'unset', margin: '0 0.5rem 0.5rem 0.5rem'}} defaultValue={searchTerm} placeholder={I18n.t('search')} type='text' onChange={handleTermChange} />
    {!loading && projects.length == 0 && <span style={{marginLeft: '0.5rem'}}className='description'>{noItemsText}</span>}
    {loading && <LoadingIndicator size='sm'/>}
    {!loading && projects.map(project => <ProjectMenuItem key={project[1]} project={project} handleItemClick={handleItemClick}/>)}
  </>
}

export function ProjectQuickFilter({onChangeProjectContext, noFilterProps = {}, menuProps = {}}){
  const [mostRecent, setMostRecent] = useState(null)
  const [activeItem, setActiveItem] = useState(NO_FILTER)
  
  const handleItemClick = (item) => {
    onChangeProjectContext(item == NO_FILTER ? null : item[0]);

    // Display the previous item to easily switch between two
    if (activeItem && activeItem != NO_FILTER) {
       setMostRecent([...activeItem]);
    } else if (mostRecent && item[0] == mostRecent[0] ) {
      setMostRecent(null);
    }


    setActiveItem(item == NO_FILTER ? NO_FILTER : [...item])
  }

  const activeStyle = (id) => activeItem[0] == id ? ACTIVE_STYLE : {}

  return <div>
    <div style={{marginTop: 0, marginLeft: 5}} className="description">{noFilterProps?.title || I18n.t('project').toUpperCase()}</div>
    <div className="btn-group" role="group">
      <FilterButton {...noFilterProps} style={activeStyle(NO_FILTER[0])} onClick={() => handleItemClick(NO_FILTER)}>
        {noFilterProps?.text || NO_FILTER[1]}
      </FilterButton>
      {mostRecent && <FilterButton onClick={() => handleItemClick(mostRecent)}>{mostRecent[1]}</FilterButton>}

      <div className={`btn-group ${menuProps.dropup && 'dropup'}`} role="group">
      <DropdownMenu
        menuItems={<ProjectSearchMenu handleItemClick={handleItemClick} />}
        menuProps={menuProps}
      >
        <FilterButton 
          style={{...activeStyle(activeItem != NO_FILTER && activeItem[0]), borderTopLeftRadius: 0, borderBottomLeftRadius: 0}}
        > 
          {activeItem == NO_FILTER ? '•••' : <>{activeItem[1]}<span className='caret' style={{borderColor: '#FFF'}}/></>}
        </FilterButton>      
      </DropdownMenu>
      </div>

    </div>
  </div>
}

const ProjectSearchMenu = ({handleItemClick}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleTermChange = (event) => {
    if (event.target.value.length > 2) setLoading(true);
    setSearchTerm(event.target.value)
  }

  // TODO: Abort request.
  const fetchProjects = () => {
    if (searchTerm.length > 2) {
      fetchJson(search_projects_by_identifier_path({term: searchTerm, limit: 20})).then(response => {
        setProjects(response);
        setLoading(false);
      })
    }
  }

  const debouncedFetch = _.debounce(fetchProjects, 500);

  useEffect(debouncedFetch, [searchTerm])

  const items = <MenuContent 
    searchTerm={searchTerm} 
    handleTermChange={handleTermChange} 
    projects={projects}
    handleItemClick={handleItemClick} 
    loading={loading}
  />

  return items;
}